
import React from "react";
import { ArrowLeft } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";

interface ClassDetailErrorProps {
  isEvent?: boolean;
}

const ClassDetailError: React.FC<ClassDetailErrorProps> = ({ isEvent = false }) => {
  const navigate = useNavigate();
  
  return (
    <div className="rounded-lg border bg-card text-card-foreground shadow p-6">
      <div className="text-center py-10">
        <h2 className="text-xl font-semibold text-destructive">Error Loading {isEvent ? 'Event' : 'Class'}</h2>
        <p className="text-muted-foreground mt-2">
          We couldn't load the {isEvent ? 'event' : 'class'} details. Please try again later.
        </p>
        <Button 
          variant="secondary" 
          onClick={() => navigate(-1)} 
          className="mt-4"
        >
          <ArrowLeft className="mr-2 h-4 w-4" /> Go Back
        </Button>
      </div>
    </div>
  );
};

export default ClassDetailError;
